module.exports = __webpack_public_path__ + "img/12加入我们-img3.37bd9f5f.jpg";